import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=6f6ca80b"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6ca80b')) {
      api.createRecord('6f6ca80b', component.options)
    } else {
      api.reload('6f6ca80b', component.options)
    }
    module.hot.accept("./LocaleSwitcher.vue?vue&type=template&id=6f6ca80b", function () {
      api.rerender('6f6ca80b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocaleSwitcher.vue"
export default component.exports